<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    name: string
    showIfFavorite: boolean
    restaurantCode: string
    city: string
    heading?: boolean
    smallFont?: boolean
  }>(),
  {
    smallFont: false,
  }
)

const emit = defineEmits(['close'])

const { t } = useLocale()
const authStore = useAuthStore()
const { restaurantDetailRoute } = useMcdRoutes()

const { isFavorite, toggleFavorite } = useFavoriteRestaurant(props.restaurantCode)
</script>

<template>
  <div class="flex items-center justify-between">
    <h1
      v-if="heading"
      class="truncate font-bold leading-4 tracking-[-0.15px]"
      :class="smallFont ? 'text-xs' : 'text-sm'"
    >
      {{ name }}
    </h1>
    <p
      v-else
      class="truncate font-bold leading-4 tracking-[-0.15px]"
      :class="smallFont ? 'text-xs' : 'text-sm'"
    >
      {{ name }}
    </p>
    <div v-if="showIfFavorite" class="flex flex-row gap-1">
      <img
        v-if="authStore.isUserLogged"
        class="cursor-pointer"
        :src="
          isFavorite
            ? '/images/icons/favoriteFilled.svg'
            : '/images/icons/profileSections/favorite.svg'
        "
        alt="favorite icon"
        @click="toggleFavorite"
      />
      <PrimeTooltip append-value="body" landing-class="!m-0 ">
        <template #actionElement="{ toggle }">
          <Btn class="w-6" icon="pi pi-ellipsis-v" @click="toggle" />
        </template>
        <template #tooltipContent="{}">
          <NuxtLink
            class="btn-secondary flex h-10 w-32 items-center justify-center py-1 text-sm leading-4"
            :to="restaurantDetailRoute(restaurantCode, name, city)"
            @click="emit('close')"
          >
            {{ t('common.seeDetail') }}
          </NuxtLink>
        </template>
      </PrimeTooltip>
    </div>
  </div>
</template>

<style scoped>
.p-button {
  width: 1.5rem;
  color: #292929;
  background: #ffffff;
  border: 1px solid #ffffff;
  font-size: 1rem;
  border-radius: 6px;
  transition: none;
  padding: 0;
}

.p-button:enabled:focus {
  background: #ffffff;
  color: #292929;
  border-color: #ffffff;
  box-shadow: none;
}

.p-button:enabled:hover {
  background: #ffffff;
  color: #292929;
  border-color: #ffffff;
}

.p-button:enabled:active {
  background: #ffffff;
  color: #292929;
  border-color: #ffffff;
}
</style>
